module.exports = __webpack_public_path__ + "6227.7c5353afdfac1e131cdb90e571e9eb4c.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/6227.png
// module id = 490
// module chunks = 0